
import { css } from 'lit';
export default css`
:host{
  --pc-personal-perkins-height-with-image:89px;
  --pc-personal-perkins-height-without-image:82px;

  --pc-personal-border-width-mobile:3px;
  --pc-personal-border-width:4px;

  display:block;
}

.personal-quote{
  display:block;
}

.container{
  display:flex;
  flex-direction:column-reverse;
  gap:var(--spacing-6);
}

.image{
  z-index:1;
  margin-left:calc(var(--spacing-8) * -1);
}

.quote{
  display:flex;
  position:relative;
  flex-direction:column;
  justify-content:center;
  gap:var(--spacing-4);
  margin:0;
  margin-right:calc(var(--spacing-8) * -1);
  border:var(--pc-personal-border-width-mobile) solid var(--purple-indigo-light);
  border:var(--pc-personal-border-width-mobile) solid var(--pc-personal-quote-border-quote, var(--purple-indigo-light));
  border-right:0;
  padding:var(--spacing-6) var(--spacing-8);
}

.quote::after{
  display:block;
  position:absolute;
  bottom:-70px;
  left:-175px;
  box-sizing:border-box;
  border:var(--pc-personal-border-width-mobile) solid var(--purple-indigo-light);
  border:var(--pc-personal-border-width-mobile) solid var(--pc-personal-quote-border-quote, var(--purple-indigo-light));
  border-radius:64px 0 0 64px;
  width:175px;
  height:70px;
  content:'';
}

.without-image{
  padding-bottom:70px;
}

.without-image .image{
  display:none;
}

.pc-hero{
  padding-block:3rem;
}

.pc-hero .container{
    flex-direction:column;
  }

.pc-hero .quote{
    margin-left:1.5rem;
  }

.pc-hero .quote::after{
    top:-70px;
  }

@media (min-width: 768px){
  .image{
    width:calc(50% + var(--spacing-8));
  }
}

@media (min-width: 992px){
  .personal-quote{
    padding-bottom:calc(
      var(--pc-personal-perkins-height-with-image) -
        var(--pc-personal-border-width)
    );
  }

  .container{
    display:grid;
    grid-template-columns:repeat(2, 50%);
    gap:0;
  }
    .pc-hero.personal-quote{
      padding-top:calc(
        var(--pc-personal-perkins-height-with-image) -
          var(--pc-personal-border-width)
      );
    }
    .pc-hero .image{
      margin-top:var(--spacing-6);
      margin-bottom:var(--spacing-0);
    }

    .pc-hero .container{
      grid-template-columns:40% 60%;
    }
    .pc-hero .quote{
      margin-left:0rem;
      border-right:0;
    }
    .pc-hero .quote::after{
      top:calc(var(--pc-personal-perkins-height-with-image) * -1);
    }

  .image{
    margin-bottom:var(--spacing-6);
    margin-left:0;
    width:100%;
  }

  ::slotted([slot='image']){
    margin-right:calc(var(--spacing-4) * -1);
  }

  .quote{
    gap:var(--spacing-6);
    margin:0;
    border:var(--pc-personal-border-width) solid var(--purple-indigo-light);
    border:var(--pc-personal-border-width) solid var(--pc-personal-quote-border-quote, var(--purple-indigo-light));
    padding:var(--spacing-6) var(--spacing-12);
  }

  .quote::after{
    bottom:calc(var(--pc-personal-perkins-height-with-image) * -1);
    left:-223px;
    border-width:var(--pc-personal-border-width);
    width:223px;
    height:var(--pc-personal-perkins-height-with-image);
  }

  .without-image{
    padding-bottom:calc(
      var(--pc-personal-perkins-height-without-image) -
        var(--pc-personal-border-width)
    );
  }

  .without-image .container{
    grid-template-columns:calc((8 / 12) * 100%);
    justify-content:center;
  }

  .without-image .quote{
    padding:var(--spacing-8) var(--spacing-12);
  }

  .without-image .quote::after{
    bottom:calc(var(--pc-personal-perkins-height-without-image) * -1);
    left:-167px;
    width:167px;
    height:var(--pc-personal-perkins-height-without-image);
  }
}

@media (min-width: 1280px){
  .quote{
    padding:var(--spacing-8) var(--spacing-16);
  }
}

:host([pc-hero-carousel]) .quote{
  padding-bottom:var(--spacing-16);
}
`;